import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend'; // Used to load translations from /public/locales

i18n
  // Load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(HttpApi)
  // Detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // Init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // debug: true, // Uncomment to enable debug output
    fallbackLng: 'en', // Use English if detected language is not available
    interpolation: {
      escapeValue: false, // Not needed for React as it escapes by default
    },
    // Define where resources are stored
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to translation files
    },
    // Define supported languages (optional, but recommended)
    supportedLngs: ['en', 'fr'],
    // Default namespace (optional)
    ns: 'translation', 
    defaultNS: 'translation',
  });

export default i18n; 